import {createContext} from "react";

let appContext = createContext({})


export default appContext
